import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  DealerService,
  UpdateDealerRequest,
} from '../../services/DealerService';

export const fetchDealer = createAsyncThunk(
  'fetchDealer',
  async (dealerId: string) =>
    DealerService.getDealer(dealerId).then((result) => result.data),
);

export const updateDealer = createAsyncThunk(
  'updateDealer',
  async (arg: UpdateDealerRequest) =>
    DealerService.updateDealer(arg).then((result) => result.data),
);
